import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import cargandoCard from "../../../components/cargando-card";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_MODAL_ACEPTAR, ESTILO_INPUT_GENERICO, ESTILO_SECCION_BOTON_DOWN } from "../../../utils/const/estilos-const";
import {
  actualizarFormularioDetallePieDePagina,

  guardarDetallePieDePagina,



  obtenerDetalleListaPieDePagina,

} from "../../../api/api-pie-de-pagina";
import Select from "react-select";
import { LIST_PIE_DE_PAGINA, SELECT_PIE_DE_PAGINA } from "./const_select_pie_de_pagina";
import { ArrowDownCircle, ArrowUpCircle, Save } from "feather-icons-react/build/IconComponents";
import SwitchComponent from "../../../components/switch";
import { PIE_DE_PAGINA } from "../../../utils/const/int-const";
import { useTranslation } from "react-i18next";

export default function PieDePagina() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [inputFormularioSelected, setInputFormularioSelected] = useState(null);
  const [listaInputs, setListaInputs] = useState([]);
  const [idPieDePagina, setIdPieDePagina] = useState(null);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      setIdPieDePagina(data.params.id);
      let objEnviar = {};
      objEnviar.idPieDePagina = data.params.id;
      const infoFormularioChecklist = await obtenerDetalleListaPieDePagina(objEnviar);
      // console.log("infoFormularioChecklist");
      // console.log(infoFormularioChecklist);
      if (infoFormularioChecklist.length > 0) {
        let lista = [];
        for (let i = 0; i < infoFormularioChecklist.length; i++) {
          const element = infoFormularioChecklist[i];
          let obj = {
            id: element.id,
            idPieDePagina: data.id,
            idConcepto: element.idConcepto,

            text: element.text,
            habilitado: element.habilitado,
            orden: element.orden,
            obligatorio: element.obligatorio,
          };
          lista.push(obj);
        }
        setListaInputs(lista);
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    }
  }

  const handleAtrasClick = () => {
    history.goBack();
  };

  const handleAgregarClick = async () => {
    // console.log('handleAgregarClick');
    if (inputFormularioSelected === null) {
      return;
    }
    // console.log('inputFormularioSelected');
    // console.log(inputFormularioSelected);
    // console.log('existe');
    // console.log(existe);
    let text = "";
    if (inputFormularioSelected.value === LIST_PIE_DE_PAGINA.FIRMA) {
      text = "FIRMA";
    }
    let newInput = {
      idPieDePagina: idPieDePagina,
      idConcepto: inputFormularioSelected.value,
      text: text,
      orden: listaInputs.length,
      habilitado: true,
      obligatorio: false,
    };
    const guardoNuevo = await guardarDetallePieDePagina(newInput);
    // console.log('guardoNuevo');
    // console.log(guardoNuevo);
    if (guardoNuevo.error === false) {
      newInput.id = guardoNuevo.id;
      setListaInputs([...listaInputs, newInput]);
    }
    if (guardoNuevo.error === true) {
      alert(t('alert_no_se_pudo_agregar_nuevo_input'));
    }
  };

  const handleInputChange = (event, indexInput) => {
    // console.log('handleInputChange');
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    // setListaInputs([ ...checklistSelected, [name]: value ]);
    setListaInputs((prevListInputs) =>
      prevListInputs.map((item, index) =>
        index === indexInput ? { ...item, [name]: value } : item
      )
    );
  };

  const renderListInputs = () => {
    try {
      // console.log('renderListInputs');
      // console.log(listaInputs);
      return (
        <>
          {listaInputs.map((input, index) => (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row'
                }}
              >
                <div
                  style={{
                    width: '30%'
                  }}
                >
                  <li key={input.id}>
                    {t('label_tipo')}: {input.label}
                  </li>
                  {input.idConcepto === PIE_DE_PAGINA.INPUT_LABEL &&
                    <input
                      type="text"
                      name="text"
                      className={ESTILO_INPUT_GENERICO}
                      maxLength={128}
                      placeholder="EJEMPLO"
                      onChange={e => { handleInputChange(e, index); }}
                      value={input.text}
                    />
                  }
                  {input.idConcepto === PIE_DE_PAGINA.INPUT_LINEA_VACIA &&
                    <input
                      type="text"
                      name="text"
                      className={ESTILO_INPUT_GENERICO}
                      maxLength={128}
                      placeholder=" _____________"
                      onChange={e => { handleInputChange(e, index); }}
                      value={input.text}
                    />
                  }
                  {input.idConcepto === PIE_DE_PAGINA.FIRMA &&
                    <input
                      type="text"
                      name="text"
                      className={ESTILO_INPUT_GENERICO}
                      maxLength={128}
                      placeholder={t("label_firma")}
                      onChange={e => { handleInputChange(e, index); }}
                      value={input.text}
                      readOnly
                    />
                  }
                </div>
                <div
                  style={{
                    width: '5%'
                  }}
                >
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '20%',
                    alignItems: 'center',
                  }}
                >
                  {index > 0 && <button
                    type="button"
                    className={ESTILO_SECCION_BOTON_DOWN}
                    onClick={() => { moverSeccionUpClick(index); }}
                    title={t('label_mover_input_arriba')}
                  >
                    <ArrowUpCircle />
                  </button>}

                  {index < listaInputs.length - 1 &&
                    <button
                      type="button"
                      className={ESTILO_SECCION_BOTON_DOWN}
                      onClick={() => { moverSeccionDownClick(index); }}
                      title={t('label_mover_input_abajo')}
                    >
                      <ArrowDownCircle />
                    </button>}

                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '20%',
                    alignItems: 'center',
                  }}
                >
                  <SwitchComponent isOn={input.habilitado} handleToggle={() => { handleToggle(input, index); }} />
                  <p className="ml-4" >{input.habilitado ? t('label_activo') : t('label_no_activo')}</p>
                </div>
                <div
                  style={{
                    width: '5%'
                  }}
                ></div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '20%',
                    alignItems: 'center',
                  }}
                >
                  <SwitchComponent isOn={input.obligatorio} handleToggle={() => { handleToggleObligatorio(input, index); }} />
                  <p className="ml-4" >{input.obligatorio ? t('label_obligatorio') : t('label_no_obligatorio')}</p>
                </div>
              </div>
              <br />
              <hr />
              <br />
            </>
          ))}
        </>
      );
    } catch (err) {
      console.log('render err renderListInputs');
      console.log(err);
      return (
        <div className="m-8" >
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  const handleToggle = async (input, indexInput) => {
    try {
      // console.log('handleToggle');
      // console.log(input);
      // console.log(indexInput);
      setListaInputs((prevListInputs) =>
        prevListInputs.map((item, index) =>
          index === indexInput ? { ...item, habilitado: !item.habilitado } : item
        )
      );
    } catch (err) {
      console.log('handleToggle err');
      console.log(err);
    }
  };

  const handleToggleObligatorio = async (input, indexInput) => {
    try {
      // console.log('handleToggle');
      // console.log(input);
      // console.log(indexInput);
      setListaInputs((prevListInputs) =>
        prevListInputs.map((item, index) =>
          index === indexInput ? { ...item, obligatorio: !item.obligatorio } : item
        )
      );
    } catch (err) {
      console.log('handleToggle err');
      console.log(err);
    }
  };

  const moverSeccionUpClick = async (index) => {
    // console.log('moverSeccionUpClick');
    // console.log(index);
    if (index === 0) return; // No mover si es el primer elemento
    // let objEnviar = { };
    // objEnviar.objetoA = listaInputs[index];
    // objEnviar.objetoB = listaInputs[index - 1];
    swapItems(index, index - 1);
  };

  const swapItems = (index1, index2) => {
    setListaInputs((prevListInputs) => {
      const newList = [...prevListInputs]; // Create a shallow copy of the array
      if (index1 >= 0 && index2 >= 0 && index1 < newList.length && index2 < newList.length) {
        [newList[index1], newList[index2]] = [newList[index2], newList[index1]]; // Swap elements
        newList[index1] = { ...newList[index1], orden: index1 };
        newList[index2] = { ...newList[index2], orden: index2 };
      }
      return newList;
    });
  };

  const moverSeccionDownClick = async (index) => {
    // console.log('moverSeccionDownClick');
    // console.log(index);
    if (index === listaInputs.length - 1) return; // No mover si es el último elemento
    // let objEnviar = { };
    // objEnviar.objetoA = listaInputs[index];
    // objEnviar.objetoB = listaInputs[index + 1];
    swapItems(index, index + 1);
  };

  const onPressGuardarFormuario = async () => {
    try {
      // console.log('onPressGuardarFormuario');
      // console.log('idPieDePagina', idPieDePagina);
      for (let i = 0; i < listaInputs.length; i++) {
        listaInputs[i].idPieDePagina = idPieDePagina;
      }
      // console.log('listaInputs', listaInputs);
      let countError = 0;
      for (let j = 0; j < listaInputs.length; j++) {
        const element = listaInputs[j];
        const resp = await actualizarFormularioDetallePieDePagina(element);
        // console.log('resp');
        // console.log(resp);
        if (resp.error === true) {
          countError = countError + 1;
        }
      }
      if (countError > 0) {
        alert(t('alert_no_se_pudo_actualizar_todos_los_inputs_intente_nuevamente'));
      }
      if (countError === 0) {
        alert(t('alert_se_actualizo_correctamente'));
        handleAtrasClick();
      }
    } catch (err) {
      console.log('onPressGuardarFormuario err');
      console.log(err);
    }
  };

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      return (
        <div className="pt-4 px-4 " >
          <div className="flex justify-between">
            <div className="flex justify-center align-center">
              <label
                style={{
                  paddingLeft: 10,
                  fontWeight: 'bold',
                }}
              >
                {t('titulo_formulario_checklist')}
              </label>
            </div>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                {t('btn_atras')}
              </button>
            </div>
          </div>
          <hr />
          <br />
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
              <label className="font-bold">{t('label_seleccione_input')}</label>
              <div
                className="flex"
              >
                <Select
                  options={SELECT_PIE_DE_PAGINA}
                  isSearchable={true}
                  isClearable={true}
                  value={inputFormularioSelected}
                  onChange={(e) => {
                    setInputFormularioSelected(e);
                  }}
                  placeholder={t('label_seleccione_input')}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: '350px' // Set your desired width here
                    })
                  }}
                />
                <div
                  className={ESTILO_BOTON_GENERAL_ACEPTAR}
                  style={{ marginRight: '16px' }}
                >
                  <button
                    type="button"
                    onClick={handleAgregarClick}
                  >
                    {t('btn_agregar')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <hr />
          {renderListInputs()}
          <div className="flex flex-row justify-end mb-8">
            <button
              className={`${ESTILO_BOTON_MODAL_ACEPTAR} flex items-center`}
              onClick={() => { onPressGuardarFormuario(); }}
              title={t('titulo_guardar_preguntas')}
            >
              <Save className="mr-2" />
              {t('btn_guardar')}
            </button>
          </div>
        </div>
      );
    } catch (err) {
      console.log('render err PieDePagina');
      console.log(err);
      return (
        <div className="m-8" >
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}